import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import GlobalStyles from '../css/utils/global-styles'
import TypographyStyles from '../css/utils/typography-styles'
import ColorStyles from '../css/utils/color-styles'
import HelperStyles from '../css/utils/helper-styles'
import ButtonStyles from '../css/utils/button-styles'
import TextStyles from '../css/utils/text-styles'
import IconStyles from '../css/utils/icon-styles'
import EditorialGrid from '../css/utils/editorial-grid'

export default function Layout({ children }) {
  return (
    <>
      <Helmet
        bodyAttributes={{
          class: 'editorial-body',
        }}
      />

      <div className="editorial">
        <style>{TypographyStyles}</style>
        <style>{ColorStyles}</style>
        <style>{GlobalStyles}</style>
        <style>{HelperStyles}</style>
        <style>{ButtonStyles}</style>
        <style>{TextStyles}</style>
        <style>{IconStyles}</style>
        <style>{EditorialGrid}</style>
        {children}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.array,
}
